"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var globalClient;
var _default = {
  setClient: function setClient(client, override) {
    if (globalClient && !override) {
      throw new Error('Attempting to override an existing client. This is probably an error. If you really want to do this, use setClient(client, true)');
    }

    globalClient = client;
  },
  getClient: function getClient() {
    if (!globalClient) {
      throw new Error('No client was set for backbone-hub-http. Did you forget to call setClient?');
    }

    return globalClient;
  }
};
exports.default = _default;
module.exports = exports.default;